import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IconDialogComponent } from '../../../dialogs';
import { IPayCategory } from '../../pay-categories.type';

/**
 * Handles display of dump card
 */
@Component({
	selector: 'app-settings-card',
	styleUrls: ['./settings-card.component.scss'],
	templateUrl: './settings-card.component.html'
})
export class SettingsCardComponent implements OnInit {
	constructor(private dialog: MatDialog) {
		this.dialogConfig = new MatDialogConfig();
	}

	@Output() public onChange: EventEmitter<IPayCategory> = new EventEmitter();
	@Input() public payCategory: IPayCategory;
	@Input() public isArchived: boolean;

	public iconDialogRef: MatDialogRef<IconDialogComponent>;
	public dialogConfig: MatDialogConfig;
	public payWorkdayCategory: string[] = [
		'FLIGHT MTX',
		'INSTRUCTOR',
		'INCEN',
		'LOADPAY',
		'ONCALL',
		'PERDIEM',
		'PHONE',
		'PILOT TRICK',
		'RECON'
	];
	public result: string = '';

	public ngOnInit(): void {
		if (!this.payCategory) {
			return;
		}
	}

	public isNeedChange(): void {
		this.onChange.emit(this.payCategory);
	}

	/**
	 * Icon Dialog
	 */
	public openIconDialog(): void {
		this.dialogConfig.disableClose = false;
		this.dialogConfig.autoFocus = true;
		this.dialogConfig.width = '30%';
		this.dialogConfig.height = '30%';
		this.dialogConfig.panelClass = 'icon-dialog';
		this.dialogConfig.data = {};

		if (this.dialog) {
			this.iconDialogRef = this.dialog.open(IconDialogComponent, this.dialogConfig);
		}
		if (this.iconDialogRef) {
			this.iconDialogRef.beforeClosed().subscribe((result: string) => {
				this.result = result;
			});
			this.iconDialogRef.afterClosed().subscribe((icon: string) => {
				if (icon) {
					this.payCategory.iconName = icon;
					this.isNeedChange();
				}
				this.iconDialogRef = null;
			});
		}
	}

	public onExportToWorkdayChange(): void {
		if ((this.payCategory.exportToWorkday || this.payCategory.isFlightTime) && !this.payCategory.factorAmount) {
			this.payCategory.factorAmount = null;
		}
	}

	public onFlightTimeChange(value: boolean): void {
		if (value && !this.payCategory.exportToWorkday) {
			this.payCategory.exportToWorkday = value;
			this.payCategory.factorAmount = null;
		}
	}
}
